import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends ApiService {
  public url: string = this.getBaseUrl();
  public url_onlineinventory: string = this.getBaseUrl_inventory();
  public url_orderbiling: string = this.getBaseUrl_orderbilding();

  //================ Address ===================
  LoadAddress(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'address_3apps/selall', { headers: header });
  }
  new_address(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'address_3apps/new', param, { headers: header });
  }
  update_address(param: any, id: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'address_3apps/edit/' + id, param, { headers: header });
  }
  ChangeLocation(id: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'address_3apps/changeLocation/' + id, {}, { headers: header });
  }
  delete_address(id: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'address_3apps/del/' + id, {}, { headers: header });
  }

  //============ Post ===================
  loadpost(type: string): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'post_3apps/selmany_by_storetype/' + type, { headers: header });
  }
  loadpost_byPostUuid(postuuid: string): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'post_3apps/selone_uuid/' + postuuid, { headers: header });
  }
  loadpost_alltype(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'post_3apps/selmany', { headers: header });
  }
  loadpost_bystoreuuid(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/selmany_bystoreuuid', data, { headers: header });
  }
  loadpost_bytags(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/GetPostByTags', data, { headers: header });
  }
  loadpost_bytags_like(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/GetPostByTags_like', data, { headers: header });
  }
  loadpost_byproducttype(type: string): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'post_3apps/selmany_by_producttype/' + type, { headers: header });
  }
  loadpost_byproducttype_apptype(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/selmany_by_producttype_apptype', param, { headers: header });
  }
  loadpost_byproducttype_storeuuid(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/selmany_byproducttype_storeuuid', param, { headers: header });
  }
  loadseconproduct(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_onlineinventory + 'product/LoadManyProductByOwnerUuidAndUUIDs/', param, { headers: header });
  }
  loadLastestStockForCart(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_onlineinventory + 'product/LoadLastestManyProductByOwnerUuidsAndUUIDsForCart/', param, { headers: header });
  }
  loadpost_bymrp_apptype(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/selmanyEX_bymrp_apptype/', param, { headers: header });
  }
  load_mrp_post_byapptype(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/selmany_mrp_post_apptype/', param, { headers: header });
  }
  load_normal_post_byapptype(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/selmany_normal_post_apptype/', param, { headers: header });
  }

  //========= post news =====

  new_postnews(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'postnews/new', param, { headers: header });
  }
  GetNewsPostBy(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'postnews/GetPostBy', param, { headers: header });
  }
  edit_postnews(param: any, id: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'postnews/edit/' + id, param, { headers: header });
  }
  del_postnews(id: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'postnews/del/' + id, {}, { headers: header });
  }


  //======= special post =========
  loaddemopost_bypstatus(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'special_post_3apps/selectdemopost_bypstatus', data, { headers: header });
  }
  loadsppost_by_pstatus(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'special_post_3apps/selmany_by_pstatus', data, { headers: header });
  }
  loadStoreByName(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'gstore_3apps/findbyname', param, { headers: header });
  }

  //=========== gstore ==========

  loadstore(storeuuid: string): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'gstore_3apps/find_by_uuid/' + storeuuid, { headers: header });
  }
  loadstore_bytype(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'gstore_3apps/selmany_bystoretype', param, { headers: header });
  }
  // loadstore_bytags(param: any): Observable<any> {
  //   const header = this.headerBase();
  //   return this.http.post(this.url + 'gstore_3apps/selmany_bytag' ,param, { headers: header });
  // }
  LoadManyByUUIDs(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'gstore_3apps/LoadManyByUUIDs/', param, { headers: header });
  }

  //=== Order ====
  new_order(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_orderbiling + 'customerorder/new', param, { headers: header });
  }
  loadMyorder(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url_orderbiling + 'customerorder/selmany/onlinestore', { headers: header });
  }
  loadorderdetails(orderUuid): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url_orderbiling + 'customerorderdetails/findByOrderUuid/' + orderUuid, { headers: header });
  }
  setordercancel(param: any, orderid: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_orderbiling + 'customerorder/setordercancel/' + orderid, param, { headers: header });
  }
  setcompleted(param: any, orderid: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_orderbiling + 'customerorder/setcompleted/' + orderid, param, { headers: header });
  }
  loadMyorder_fromMultistore(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_orderbiling + 'order/loadMyorder_fromMultistore', param, { headers: header });
  }
  customeracceptedorderchanged(param: any, id: string) {
    const header = this.headerBase();
    return this.http.post<any>(this.url_orderbiling + 'order/customeracceptedorderchanged/' + id, param, { headers: header });
  }

  // orderassign
  setcompleted_orderassign(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_orderbiling + 'orderassign/setcompleted_orderassign', param, { headers: header });
  }


  //============ paymentmethodfee and shipmentmethodfee ===================
  loadpayment(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'paymentmethodfee/selmany/', { headers: header });
  }
  loadshipment(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'shipmentmethodfee/selmany/', { headers: header });
  }


  //==== category =======

  cat_selmany(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url_onlineinventory + 'gproducttype/selmany/', { headers: header });
  }
  cat_ex(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url_onlineinventory + 'gproducttype/selmany_ex/', { headers: header });
  }
  // cat_selmany_apptype(param: any): Observable<any> {
  //   const header = this.headerBase();
  //   return this.http.post(this.url_onlineinventory + 'gproducttype/selmany_byAppType',param, { headers: header });
  // }

  //======================== Favorite post =================
  LoadPostFavorite(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'post_3apps/LoadPostFavorite', param, { headers: header });
  }
  GetPostByPostUuid(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'post_3apps/GetPostByPostUuid', param, { headers: header });
  }
  GetPostByPostUuidArray(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'post_3apps/GetPostByPostUuidArray', param, { headers: header });
  }
  GetonePostByPostUuid(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'post_3apps/GetonePostByPostUuid', param, { headers: header });
  }
  InsertPostFavorite(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'post_3apps/InsertPostFavorite', param, { headers: header });
  }
  DeletePostFavorite(id: string): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'post_3apps/delfavorite/' + id, {}, { headers: header });
  }



  GetManyGstoreNameByProfileUuid(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'post/GetManyGstoreNameByProfileUuid', param, { headers: header });
  }
  GetProfileUuidByOwnerUuid(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'profile/GetProfileUuidByOwnerUuid', param, { headers: header });
  }
  LoadStoreByProfileUuid(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'gstore/getbyprofileuuid?q=' + param, {}, { headers: header });
  }


  // ============= tags =============
  loadtags(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url + 'tag3apps/selmany_all', { headers: header });
  }

  // ======== vending post ========
  loadmany_vendingpost(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'selfservice_post/selmany', param, { headers: header });
  }
  loadmany_vendingpost_bytags(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'selfservice_post/GetPostByTags', param, { headers: header });
  }
  loadmany_vendingpost_bytagslike(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'selfservice_post/GetPostByTags_like', param, { headers: header });
  }
  loadvendingpost_byproducttype_storeuuid(param: any): Observable<any> {
    const header = this.headerBase()
    return this.http.post(this.url + 'selfservice_post/selmany_byproducttype_storeuuid', param, { headers: header });
  }
  loadtags_vending(): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'selfservice_post/SelectAllTags', {}, { headers: header });
  }
  loadActiveVendingpost_bystoreUuid(param: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'selfservice_post/findBystoreUuid', param, { headers: header });
  }

  //================== Category Vending ======================
  cat_vending_selmany(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_onlineinventory + 'category_vending/selmany', data, { headers: header });
  }
  cat_vending_selmany_ex(): Observable<any> {
    const header = this.headerBase();
    return this.http.get(this.url_onlineinventory + 'category_vending/selmany_ex', { headers: header });
  }

  //========== LAAB ===============
  loadReciverLAAB(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url + 'gstore_3apps/findReciverLAAB', data, { headers: header });
  }
  confirmUserPayLAAB(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_orderbiling + 'paymentdetails/confirmUserPayLAAB', data, { headers: header });
  }

  //======== product must pay first =====
  findByUuidArray_cart(data: any): Observable<any> {
    const header = this.headerBase();
    return this.http.post(this.url_onlineinventory + 'productmustpayfirst/findByUuidArray_cart', data, { headers: header });
  }
}
